export default __webpack_public_path__ + "static/LogoLarge-681cb556a9bdc3b6f47f3e774a1f7e46.svg";